import {
  textareaSchema,
  textareaUI,
  yesNoUI,
  yesNoSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Your most recent employment and disability benefits'),
    'ui:description':
      'We’ll ask why you left your most recent job or self-employment and whether you receive or expect to receive disability-related benefits.',
    leftDueToDisability: yesNoUI({
      title:
        "Did you leave your last job or self-employment because of your disability? If yes, you'll need to provide more information next.",
      errorMessages: {
        required:
          'Select a response to tell us if your disability is the reason you left your last job',
      },
    }),
    disabilityLeavingExplanation: textareaUI({
      title: 'Please explain how your disability led you to leave your job.',
      expandUnder: 'leftDueToDisability',
      expandUnderCondition: true,
      charcount: true,
      maxlength: 1000,
      required: formData => formData.leftDueToDisability === true,
      errorMessages: {
        required:
          'Enter an explanation of how your disability affected your job',
      },
    }),
    receivesDisabilityRetirement: yesNoUI({
      title:
        'Do you receive, or do you expect to receive disability retirement benefits?',
      errorMessages: {
        required:
          'Select a response to tell us if you currently receive disability retirement benefits or if you expect to receive them',
      },
    }),
    receivesWorkersCompensation: yesNoUI({
      title:
        'Do you receive, or do you expect to receive workers compensation benefits?',
      errorMessages: {
        required:
          'Select a response to tell us if you currently receive workers compensation benefits or if you expect to receive them',
      },
    }),
  },
  schema: {
    type: 'object',
    properties: {
      leftDueToDisability: yesNoSchema,
      disabilityLeavingExplanation: { ...textareaSchema, maxLength: 1000 },
      receivesDisabilityRetirement: yesNoSchema,
      receivesWorkersCompensation: yesNoSchema,
    },
    required: [
      'leftDueToDisability',
      'receivesDisabilityRetirement',
      'receivesWorkersCompensation',
    ],
  },
};
